import axios from './axios'

export function getCodeAPI(sub) {
  return axios({
    method: "post",
    url: '/api/v1/password/forget/',
    data: sub
  })
}

export function forgotPassword(sub) {
  return axios({
    method: "post",
    url: '/api/v1/password/reset/',
    data: sub
  })
}

export function changePassword(sub) {
  return axios({
    method: "post",
    url: '/api/v1/password/change/',
    data: sub
  })
}
